import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/walkthroughs/')({
  beforeLoad: () => {
    throw redirect({ to: '/', replace: true })
  },
})
